import { type CountryCode, geoResponseSchema } from '@noconflict/contracts';
import { apiFetch } from '../../../shared/api/http';

/** The visitor's country according to the worker (`GET /api/geo`). A convenience: any failure is just null. */
export async function fetchGeoCountry(): Promise<CountryCode | null> {
  try {
    return (await apiFetch('/api/geo', geoResponseSchema)).country;
  } catch {
    return null;
  }
}
